//=include _owl.carousel.min.js

$(document).ready(function() {
	if ($('#carrousel_temoignages').length > 0) {
		$('#carrousel_temoignages').owlCarousel({
			margin: 30,
			//autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			responsive: {
				0: {
					items: 1,
					loop: $('#carrousel_temoignages .temoignage').length > 1 ? true : false
				},
				768: {
					items: 2,
					loop: $('#carrousel_temoignages .temoignage').length > 2 ? true : false
				},
				1024: {
					items: 3,
					loop: $('#carrousel_temoignages .temoignage').length > 3 ? true : false
				}
			}
		});
	}
});
